const LettersMap = { surname: 's', name: 'n', patronymic: 'p' };

const brace = (string) => `{${string}}`;

// prettier-ignore
export const createPersonTitleFormatter = (format, map = LettersMap) => {
    const lettersToFinalClearRe = RegExp([
        '{[',
        Object.values(map).reduce(
            (acc, letter) => acc
                .concat(letter)
                .concat(letter.toUpperCase()),
            ''
        ),
        ']}',
        '[^[:alphanum]]*'
    ].join(''), 'g');

    const safeFormat = format.replace(/(\w)/g, brace('$1'));

    return (person) => Object.entries(person)
        .reduce(
            (formatted, [key, value]) => ['', null, undefined].includes(value)
                ? formatted
                : formatted
                    .replace(brace(map[key]), value[0] ?? '')
                    .replace(brace(map[key].toUpperCase()), value),
            safeFormat
        )
        .replace(lettersToFinalClearRe, '')
        .replace(/\s+/g, ' ')
        .replace(/(^\s|\s$)/, '');
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const resolveIconClass = (iconName) => `mdi mdi-${iconName}`;

export const escapeRegExp = (input) => {
    const source = typeof input === 'string' || input instanceof String ? input : '';
    return source.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
